<template>
    <div class="order_btn">
        <el-button type="primary" @click="refundComplete">
           {{ buttonName }}
        </el-button>
    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import orderMixins from "@/mixins/orderMixins";

export default {
    name: "ChangeCompleteComponent",
    mixins: [alertMixins,orderMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        orderKey :{default:0},
        status:'',
        buttonName :{default:'환불완료 처리'}
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        refundComplete(){
            EventBus.$emit('changeLoading',true)
           let params = {
               c_idx:this.orderKey.toString(),
               c_status:this.status,

           }
            try {
                this.$api.$order.updateOrderStatus(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('changeLoading',false)
                    if (res.List.Data.Status) {
                            this.afterFunc()
                    }else{
                        this.errorAlert('상태 변경 실패하였습니다.')
                    }
                })
            } catch (e) {
                console.log(e);
            }
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
